<template>
    <div>
        <el-drawer
            :visible.sync="showModal" 
            size="75%"
            @opened="onOpened"
        >   
            <template slot="title">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag class="rounded-circle" type="primary">
                        <i class="el-icon-map-location"></i>
                    </el-tag>
                    Regiões
                </div>
            </template>

            <div class="px-3">
                <div class="d-flex align-items-center justify-content-between" :style="{ gap: '20px' }">
                    <div class="d-flex align-items-center" :style="{ gap: '8px', width: '375px' }">
                        <el-input
                            v-model="filters.search" 
                            size="small" 
                            placeholder="Buscar regiões"
                            prefix-icon="el-icon-search"
                            clearable
                            :style="{ maxWidth: '375px' }"
                            @keyup.enter.native.prevent="setFiltersregiaoCdList()"
                        />

                        <el-button
                            size="small" 
                            type="primary"
                            circle
                            @click="setFiltersregiaoCdList()"
                        >
                            <i class="el-icon-search"></i>
                        </el-button>
                    </div>

                    <el-button
                        size="small" 
                        type="primary"
                        @click="openCreateRegionModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </div>

                <div class="d-flex justify-content-end mt-2">
                    <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                        <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="latest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-top mr-2"></i>
                                    Mais Recentes
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item command="oldest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-bottom mr-2"></i>
                                    Mais Antigos
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>

            <CardBase>
                <RegiaoCdList ref="regiaoCdList"/>
            </CardBase>
        </el-drawer>
        
        <!-- RegiaoCreateModal -->
        <RegiaoCreateModal ref="regiaoCreateModal" @created="handleDispatch"/>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        CheckboxGroup,
        CheckboxButton,
        RadioGroup,
        RadioButton,
        Tag,
        Drawer,
        Avatar,
        InputNumber,
        Switch,
        Dropdown, 
        DropdownMenu,
        DropdownItem,
    } from "element-ui";

    import CardBase from '@/components/_macro/CardBase.vue';
    import RegiaoCdList from "@/components/_macro/regiao_cd/RegiaoCdList.vue";
    import RegiaoCreateModal from "@/components/_macro/regiao_cd/RegiaoCreateModal.vue";

    //Api
    import { AgendaApi } from "@/api/AgendaApi";
    import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const generalResourcesApi = new GeneralResourcesApi();
    const centroDistribuicaoApi = new CentroDistribuicaoApi();

    export default {
        data() {
            return {
                cdId: null,
                showModal: false,
                isLoading: false,
                ufs: [],
                cities: [],
                cd: null,
                filters: {
                    search: '',
                    orderBy: 'latest',
                }
            }
        }, 
        methods: {
            async getCd() {
                try {
                    this.isLoading = true;

                    const res = await centroDistribuicaoApi.show(this.cdId);

                    this.cd = res;
                } catch (error) { 
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o evento. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            openCreateRegionModal() {
                this.$refs.regiaoCreateModal.payload.centro_distribuicao_id = this.cdId
                this.$refs.regiaoCreateModal.toggleModal();
            },
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },
            setFiltersregiaoCdList() {
                this.$set(this.$refs.regiaoCdList.filters, 'search', this.filters.search);
            }, 
            async handleDispatch() {
                await this.$refs.regiaoCdList.fetch();
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
             onOpened() {
                if (this.cdId != null && this.$refs.regiaoCdList) {
                    this.$refs.regiaoCdList.filters.cdId = this.cdId;
                }
            },
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        watch: {
            "filters.orderBy": {
                handler(_newValue, _oldValue) {
                    this.$set(this.$refs.regiaoCdList.filters, 'orderBy', _newValue);
                }
            },
        },
        components: {
            CardBase,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Input.name]: Input,
            [Button.name]: Button,
            [CheckboxGroup.name]: CheckboxGroup,
            [CheckboxButton.name]: CheckboxButton,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Tag.name]: Tag,
            [Drawer.name]: Drawer,
            [Avatar.name]: Avatar,
            [InputNumber.name]: InputNumber,
            [Switch.name]: Switch,
            RegiaoCdList,
            RegiaoCreateModal
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/cd/CdRegionShowModal.vue